export default "__VITE_ASSET__VadHOJM3__"